import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FormatIndianNumber } from "../utiles/FormatIndianNumber";
import TableLayout from "./TableLayout";
import useLocale from "../locales";

const FdTable = ({ showTable, timeUnit = "Years", historyData,
  shouldGenerateReport,
  setShouldGenerateReport,
  calcDone}) => {
  const {textData} = useLocale();
  const [reportData, setReportData] = useState([]);
  const { investmentAmmount, noOfFDYear, incrementPerYear, sumAmount } =
    useSelector((state) => state.fdCalculator);

  useEffect(() => {
    if (historyData) {
      generateReportFromHistory();
    } 
  }, [
    showTable, 
    investmentAmmount, 
    noOfFDYear, 
    incrementPerYear, 
    sumAmount, 
    timeUnit, 
    historyData,
    shouldGenerateReport
  ]);

  useEffect(() => {
  if (shouldGenerateReport && calcDone) {
    generateReportData();
    setShouldGenerateReport(false);
  } else if (!calcDone) {
    setReportData([]); 
  }

      generateReportFromHistory();


}, [shouldGenerateReport, calcDone,historyData]);


  const generateReportFromHistory = () => {
    if (!Array.isArray(historyData) || historyData?.length === 0) {
      return;
    }

    const fdData = historyData[0];
    const initialPrincipal = Number(historyData?.[0]?.totalInvestment);
    const R = Number(historyData?.[0]?.interestRate);
    const T = Number(historyData?.[0]?.tenure);
    const tUnit = historyData?.[0]?.tenureUnit || timeUnit;

    const n = 4;
    
    const report = [];
    let cumulativeInterest = 0;
    let principal = initialPrincipal;

    let totalPeriods;
    let periodLabel = "Year";

    switch (tUnit.toLowerCase()) {
      case "months":
        totalPeriods = T;
        periodLabel = "Month";
        break;
      case "days":
        totalPeriods = T;
        periodLabel = "Day";
        break;
      case "years":
      default:
        totalPeriods = T;
        periodLabel = "Year";
        break;
    }

    for (let period = 1; period <= totalPeriods; period++) {
      let timeInYears;
      if (tUnit.toLowerCase() === "months") {
        timeInYears = period / 12;  
      } else if (tUnit.toLowerCase() === "days") {
        timeInYears = period / 365;  
      } else {
        timeInYears = period; 
      }

      const amountAtEnd = initialPrincipal * Math.pow(1 + (R / (n * 100)), n * timeInYears);
      const interestThisPeriod = period === 1 ? 
        amountAtEnd - initialPrincipal : 
        amountAtEnd - report[period-2].cumulativeamount;
      
      cumulativeInterest += interestThisPeriod;
  
      report.push({
        year: `${period}`,
        principle: period === 1 ? Math.round(initialPrincipal) : Math.round(report[period-2].cumulativeamount),
        intrest: Math.round(interestThisPeriod),
        cumulativeintrest: Math.round(cumulativeInterest),
        cumulativeamount: Math.round(amountAtEnd),
      });
    }
  
    setReportData(report);
  };

  const generateReportData = () => {
    const initialPrincipal = Number(investmentAmmount);
    const R = Number(incrementPerYear); 
    const T = Number(noOfFDYear);
    const n = 4;  
    
    const report = [];
    let cumulativeInterest = 0;
    let principal = initialPrincipal;

    let totalPeriods;
    let periodLabel = "Year";

    switch (timeUnit.toLowerCase()) {
      case "months":
        totalPeriods = T;
        periodLabel = "Month";
        break;
      case "days":
        totalPeriods = T;
        periodLabel = "Day";
        break;
      case "years":
      default:
        totalPeriods = T;
        periodLabel = "Year";
        break;
    }

    for (let period = 1; period <= totalPeriods; period++) {
      let timeInYears;
      if (timeUnit.toLowerCase() === "months") {
        timeInYears = 1 / 12;  
      } else if (timeUnit.toLowerCase() === "days") {
        timeInYears = 1 / 365;  
      } else {
        timeInYears = 1;  
      }

      const amountAtEnd = principal * Math.pow(1 + (R / (n * 100)), n * timeInYears);
      const interestThisPeriod = amountAtEnd - principal;
      cumulativeInterest += interestThisPeriod;
  
      report.push({
        year: ` ${period}`,
        principle: Math.round(principal),
        intrest: Math.round(interestThisPeriod),
        cumulativeintrest: Math.round(cumulativeInterest),
        cumulativeamount: Math.round(amountAtEnd),
      });
  
      principal = amountAtEnd;
    }
  
    setReportData(report);
  };

  const columns = [
    { 
      key: 'year', 
      label: timeUnit.toLowerCase() === "months" ? textData.tableLabels.month : 
             timeUnit.toLowerCase() === "days" ? textData.tableLabels.day : textData.tableLabels.year, 
      format: (value) => value 
    },
    { 
      key: "principle", 
      label: `${textData.tableLabels.principle} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}` 
    },
    { 
      key: "intrest", 
      label: `${textData.tableLabels.intrest} (${textData.currency})`,  
      format: (value) => `${FormatIndianNumber(Math.round(value))}` 
    },
    { 
      key: "cumulativeintrest",
      label: `${textData.tableLabels.cumulativeintrest} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },
    { 
      key: "cumulativeamount", 
      label: `${textData.tableLabels.cumulativeamount} (${textData.currency})`, 
      format: (value) => `${FormatIndianNumber(Math.round(value))}`
    },
  ];

  return (
    <TableLayout
      showTable={showTable}
      title={`${textData.filterDropDown.FDCalc} ${textData.report}`}
      data={reportData}
      columns={columns}
      analyticsEventName="download_fd_report"
      reportTitle={textData.reportTitle.fdReport}
      fileName="fd_detail"
    />
  );
};

export default FdTable;